import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { isAdminTool } from "@/pages/settings/components/admin/utils";
import SettingsPage from "@/pages/settings/SettingsPage";

import { requiresGuardianOfTheGalaxy } from "@/providers/auth/utils";

const searchSchema = z.object({
  tool: z
    .string()
    .optional()
    .transform((value) => (isAdminTool(value) ? value : undefined)),
});

export const Route = createFileRoute("/_secure/settings/admin")({
  validateSearch: zodValidator(searchSchema),
  beforeLoad: ({ context }) => {
    requiresGuardianOfTheGalaxy(context);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <SettingsPage route="/settings/admin" />;
}
